import React from 'react';
import * as S from './styles';

type CalloutMode = 'info' | 'default';

interface CalloutProps {
    mode?: CalloutMode;
    title: string;
    description: string;
    accentColor?: string;
}

export const Callout = ({ mode = 'default', title, description, accentColor }: CalloutProps) => (
    <S.Card $mode={mode} $accentColor={accentColor}>
        <S.Title $mode={mode} $accentColor={accentColor}>{title}</S.Title>
        <S.Description $mode={mode} $accentColor={accentColor}>{description}</S.Description>
    </S.Card>
);
